import importer from "common/importer";

const getLoyaltyDetails = importer("Sagas/Loyalty/getLoyaltyDetails/main");
const getLoyaltyDetailsSuccess = importer("Sagas/Loyalty/getLoyaltyDetails/success");
const getLoyaltyDetailsFailure = importer("Sagas/Loyalty/getLoyaltyDetails/failure");

const getLoyaltyPromotions = importer("Sagas/Loyalty/getLoyaltyPromotions/main");
const getLoyaltyPromotionsSuccess = importer("Sagas/Loyalty/getLoyaltyPromotions/success");
const getLoyaltyPromotionsFailure = importer("Sagas/Loyalty/getLoyaltyPromotions/failure");

const activateLoyaltyPromotions = importer("Sagas/Loyalty/activateLoyaltyPromotions/main");
const activateLoyaltyPromotionsSuccess = importer("Sagas/Loyalty/activateLoyaltyPromotions/success");
const activateLoyaltyPromotionsFailure = importer("Sagas/Loyalty/activateLoyaltyPromotions/failure");

const getLoyaltyActivity = importer("Sagas/Loyalty/getLoyaltyActivity/main");
const getLoyaltyActivitySuccess = importer("Sagas/Loyalty/getLoyaltyActivity/success");
const getLoyaltyActivityFailure = importer("Sagas/Loyalty/getLoyaltyActivity/failure");

const getLoyaltyConstant = importer("Sagas/Loyalty/getLoyaltyContants/main");
const getLoyaltyConstantSuccess = importer("Sagas/Loyalty/getLoyaltyContants/success");
const getLoyaltyConstantFailure = importer("Sagas/Loyalty/getLoyaltyContants/failure");

const redeemRewards = importer("Sagas/Loyalty/redeemRewards/main");
const redeemRewardsSuccess = importer("Sagas/Loyalty/redeemRewards/success");
const redeemRewardsFailure = importer("Sagas/Loyalty/redeemRewards/failure");

const redeemRewardsStatusCheck = importer("Sagas/Loyalty/redeemRewardsStatusCheck/main");
const redeemRewardsStatusCheckSuccess = importer("Sagas/Loyalty/redeemRewardsStatusCheck/success");
const redeemRewardsStatusCheckFailure = importer("Sagas/Loyalty/redeemRewardsStatusCheck/failure");

const getLoyaltyGameData = importer("Sagas/Loyalty/getLoyaltyGameData/main");
const getLoyaltyGameDataSuccess = importer("Sagas/Loyalty/getLoyaltyGameData/success");
const getLoyaltyGameDataFailure = importer("Sagas/Loyalty/getLoyaltyGameData/failure");

const updateLoyaltyGameData = importer("Sagas/Loyalty/updateLoyaltyGameData/main");
const updateLoyaltyGameDataSuccess = importer("Sagas/Loyalty/updateLoyaltyGameData/success");
const updateLoyaltyGameDataFailure = importer("Sagas/Loyalty/updateLoyaltyGameData/failure");

export default {
  getLoyaltyDetails,
  getLoyaltyDetailsSuccess,
  getLoyaltyDetailsFailure,
  getLoyaltyActivity,
  getLoyaltyActivitySuccess,
  getLoyaltyActivityFailure,
  getLoyaltyConstant,
  getLoyaltyConstantSuccess,
  getLoyaltyConstantFailure,
  redeemRewards,
  redeemRewardsSuccess,
  redeemRewardsFailure,
  redeemRewardsStatusCheck,
  redeemRewardsStatusCheckSuccess,
  redeemRewardsStatusCheckFailure,
  getLoyaltyPromotions,
  getLoyaltyPromotionsSuccess,
  getLoyaltyPromotionsFailure,
  activateLoyaltyPromotions,
  activateLoyaltyPromotionsSuccess,
  activateLoyaltyPromotionsFailure,
  getLoyaltyGameData,
  getLoyaltyGameDataSuccess,
  getLoyaltyGameDataFailure,
  updateLoyaltyGameData,
  updateLoyaltyGameDataSuccess,
  updateLoyaltyGameDataFailure
};
